'use strict';

bbw.directive.bbwLayoutType = ['bbw.LayoutTypeSvc', function(layoutTypeSvc) {
    return {
        restrict: 'AE',
        scope: true,
        link: function(scope, element) {
            var el = element[0];
            layoutTypeSvc.setElement(el);
            scope.$on('$destroy', function() {
                layoutTypeSvc.unsetElement(el);
            });
        }
    };
}];
